import {RestResource} from "../rest";
import {ASSESSMENT_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const assessmentConf = new RestResource({server: ASSESSMENT_SERVER, resource: 'assessmentConf'});

assessmentConf.tree = (version) => {
    let url = `${ASSESSMENT_SERVER}/assessmentConf/tree`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, {'version': version}).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

assessmentConf.seq = (assessmentConf) => {
    let url = `${ASSESSMENT_SERVER}/assessmentConf/seq`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, assessmentConf).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

assessmentConf.up = (assessmentConf) => {
    let url = `${ASSESSMENT_SERVER}/assessmentConf/up`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, assessmentConf).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

assessmentConf.down = (assessmentConf) => {
    let url = `${ASSESSMENT_SERVER}/assessmentConf/down`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, assessmentConf).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default assessmentConf;